import Button from 'components/Button'
import ErrorBlock from 'components/ErrorBlock'
import {
  Form,
  FormRow,
  TextAreaContainer,
  TextInputContainer,
} from 'components/inputs'
import {
  ModalSheet,
  ModalSheetContent,
  ModalSheetContentBlock,
  ModalSheetContentDescription,
  ModalSheetContentIllustration,
  ModalSheetContentTitle,
  ModalSheetFooter,
  ModalSheetFooterButtonGroup,
  ModalSheetFooterSpacer,
  ModalSheetHeader,
} from 'components/ModalSheet'
import RemoveClientTeamViewModel from './RemoveClientTeamViewModel'
import { observer } from 'mobx-react'
import React from 'react'
import styles from './RemoveClientTeam.sass'
import Avatar from 'components/Avatar'

interface RemoveClientTeamDialogProps {
  vm: RemoveClientTeamViewModel
}

export default observer(function RemoveClientTeamDialog({
  vm,
}: RemoveClientTeamDialogProps) {
  return (
    <>
      <ModalSheet
        showing={vm.showing}
        onRequestClose={vm.removeClientTeam.pending ? undefined : vm.close}
        disableCloseOnEsc
        disableCloseOnOutsideClick
      >
        <ModalSheetHeader withCloseButton />

        <ModalSheetContent>
          <ModalSheetContentBlock>
            <ModalSheetContentIllustration
              src={require('assets/images/img_confirm-action.svg')}
              alt="Illustration of a confused person with a question mark bubble above their head"
            />
            <ModalSheetContentTitle>
              Are you sure you want to remove the client team from this job?
            </ModalSheetContentTitle>

            <ModalSheetContentDescription>
              The removed team will no longer have access to this job.
            </ModalSheetContentDescription>

            <Form>
              <FormRow>
                <div className={styles.clientTeamLabel}>Client team</div>
                <TextInputContainer
                  readOnly
                  disabled
                  visual={<Avatar size={24} subject={vm.currentClientTeam} />}
                  field="currentClientTeamName"
                  model={vm}
                />

                <div className={styles.reasonLabel}>Reason</div>
                <TextAreaContainer
                  model={vm}
                  field="reason"
                  name="reason"
                  error={vm.validation.getError('reason')}
                  data-test="remove-client-team-reason-input"
                  rows={3}
                />
                <div className={styles.reasonHelp}>{vm.reasonHelpText}</div>
              </FormRow>
            </Form>
          </ModalSheetContentBlock>
        </ModalSheetContent>

        {vm.removeClientTeam.rejected && (
          <ErrorBlock tackOn="bottom" error={vm.removeClientTeam.error} />
        )}

        <ModalSheetFooter>
          <ModalSheetFooterSpacer />
          <ModalSheetFooterButtonGroup>
            <Button
              type="default"
              onClick={vm.close}
              data-test="remove-client-team-close-button"
            >
              Close
            </Button>
            <Button
              type="danger"
              loading={vm.removeClientTeam.pending}
              onClick={vm.removeClientTeam}
              data-test="remove-client-team-submit-button"
            >
              Remove
            </Button>
          </ModalSheetFooterButtonGroup>
        </ModalSheetFooter>
      </ModalSheet>
    </>
  )
})
